import React from 'react';

function CodingProfiles() {
  const profiles = [
    {
      name: "LeetCode",
      rating: "1512",
      badge: "Active Solver",
      solved: "300+",
      color: "from-yellow-500 to-amber-600",
      textColor: "text-amber-500",
      bgColor: "bg-amber-500/10",
      url: "https://leetcode.com/bunnysunny24",
      icon: "🧠"
    },
    {
      name: "Codeforces",
      rating: "1011",
      badge: "Pupil",
      solved: "150+",
      color: "from-blue-500 to-indigo-600",
      textColor: "text-blue-500",
      bgColor: "bg-blue-500/10",
      url: "https://codeforces.com/profile/bunnysunny24",
      icon: "🏆"
    },
    {
      name: "CodeChef",
      rating: "1158",
      badge: "1-Star",
      solved: "100+",
      color: "from-emerald-500 to-teal-600",
      textColor: "text-emerald-500",
      bgColor: "bg-emerald-500/10",
      url: "https://www.codechef.com/users/bunnysunny24",
      icon: "🎯"
    }
  ];

  return (
    <section id="coding-profiles" className="py-24 md:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-sm font-bold text-accent uppercase tracking-wider">Competitive Programming</span>
          <h2 className="text-4xl md:text-5xl font-bold text-primary mt-2 mb-4 relative inline-block">
            Coding Profiles
            <span className="absolute -bottom-3 left-1/2 transform -translate-x-1/2 w-24 h-1.5 bg-accent rounded-full"></span>
          </h2>
          <p className="text-lg max-w-2xl mx-auto mt-8 text-gray-600 dark:text-gray-300">
            Ratings and achievements on algorithmic problem-solving platforms, focusing on Data Structures & Algorithms.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {profiles.map((profile, index) => (
            <a
              key={index}
              href={profile.url}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white dark:bg-gray-800 rounded-2xl shadow-card hover:shadow-hover border border-gray-100 dark:border-gray-700 p-8 flex flex-col justify-between items-center text-center transition-all duration-300 transform hover:-translate-y-1 relative overflow-hidden group"
            >
              {/* Card top border color strip */}
              <div className={`absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r ${profile.color}`}></div>

              <div className="mb-6">
                <span className="text-4xl p-4 bg-gray-50 dark:bg-gray-700/50 rounded-full inline-block mb-4">
                  {profile.icon}
                </span>
                <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">{profile.name}</h3>
                <span className={`px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wider ${profile.bgColor} ${profile.textColor}`}>
                  {profile.badge}
                </span>
              </div>

              <div className="w-full border-t border-b border-gray-100 dark:border-gray-700 py-4 my-4 grid grid-cols-2 gap-4">
                <div>
                  <span className="block text-xs uppercase tracking-wider text-gray-400">Rating</span>
                  <span className="text-2xl font-bold text-primary dark:text-white">{profile.rating}</span>
                </div>
                <div>
                  <span className="block text-xs uppercase tracking-wider text-gray-400">Solved</span>
                  <span className="text-2xl font-bold text-accent">{profile.solved}</span>
                </div>
              </div>

              <div className="mt-4 flex items-center text-sm font-semibold text-primary dark:text-accent-light group-hover:underline">
                <span>View Profile</span>
                <svg className="w-4 h-4 ml-1 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </a>
          ))}
        </div>

        {/* DSA Topics Info */}
        <div className="mt-16 bg-primary/5 dark:bg-gray-800/40 rounded-2xl p-8 max-w-4xl mx-auto border border-primary/10">
          <h4 className="text-xl font-bold text-primary dark:text-white mb-4 text-center">Algorithms & Data Structures Solved</h4>
          <div className="flex flex-wrap justify-center gap-3">
            {["Graphs", "Dynamic Programming", "Trees (BST, Binary Tree)", "Binary Search", "Greedy Algorithms", "Recursion", "Hashing", "Sorting", "Two Pointers"].map((topic, idx) => (
              <span key={idx} className="px-4 py-2 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 text-sm font-medium rounded-lg shadow-sm border border-gray-100 dark:border-gray-700">
                {topic}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default CodingProfiles;
